import {Component, EventEmitter, Input, Output} from "@angular/core";
import {CommonModule} from "@angular/common";
import {PopoverModule} from "primeng/popover";

@Component({
    selector: "wm-colorchooser",
    templateUrl: "./colorchooser.component.html",
    styleUrls: ['./colorchooser.component.less'],
    imports: [CommonModule, PopoverModule],
    standalone: true
})
export class ColorchooserComponent {

    // the 8 most important colors
    colors = [
        "#000000",
        "#ff0000",
        "#00ff00",
        "#0000ff",
        "#ffff00",
        "#ff00ff",
        "#00ffff",
        "#ffffff"
    ];

    @Input() color?: string;

    @Output() colorSelected = new EventEmitter<string>();

    constructor() {}

    ngOnInit() {
        if (!this.color) {
            this.color = this.colors[0];
        }
    }

    selectColor(color: string) {
        this.color = color;
        this.colorSelected.emit(color);
    }

}
